<template>
    <div class="grid">
        <div class="col-12">
            <div class="card text-center" v-if="permissionDenied">
                <h4>A kért oldal megtekintéséhez nincs jogosultsága!</h4>
            </div>
            <div class="card" v-if="!permissionDenied">
                <Toast/>

                <DataTable ref="dt" :value="templates" dataKey="id"
                           :paginator="true" :rows="10" :filters="filters" :loading="loading"
                           paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                           :rowsPerPageOptions="[5,10,25]"
                           currentPageReportTemplate="" responsiveLayout="scroll" filterDisplay="row"
                           v-model:filters="filters"
                           :globalFilterFields="['name', 'slug']">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <h5 class="m-0">Email sablonok <br> <strong><small>Összesen: {{ total }}</small></strong></h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search"/>
                                <InputText v-model="filters['global'].value" placeholder="Keresés..."/>
                            </span>
                        </div>
                    </template>

                    <Column field="id" header="#" :sortable="true" headerStyle="width:5%; min-width:3rem;">
                        <template #body="slotProps">
                            <span class="p-column-title">#</span>
                            {{ slotProps.data.id }}
                        </template>
                    </Column>
                    <Column field="name" header="Név" :sortable="true" headerStyle="width:30%; min-width:15rem;"
                            :showFilterMenu="false">
                        <template #body="slotProps">
                            <span class="p-column-title">Név</span>
                            {{ slotProps.data.name }}
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                                       class="p-column-filter" :placeholder="`Keresés...`"/>
                        </template>
                    </Column>
                    <Column field="slug" header="Slug" :sortable="true" headerStyle="width:20%; min-width:10rem;">
                        <template #body="slotProps">
                            <span class="p-column-title">Slug</span>
                            {{ slotProps.data.slug }}
                        </template>
                    </Column>
                    <Column field="subject" header="Tárgy" :sortable="true" headerStyle="width:25%; min-width:15rem;">
                        <template #body="slotProps">
                            <span class="p-column-title">Tárgy</span>
                            {{ slotProps.data.subject }}
                        </template>
                    </Column>
                    <Column headerStyle="min-width:10rem;">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                    v-tooltip.top="'Szerkesztés'" @click="edit(slotProps.data)"/>
                        </template>
                    </Column>
                    <template #empty>
                        Nincs egyetlen email sablon sem.
                    </template>
                </DataTable>

                <Dialog v-model:visible="editDialog" :breakpoints="{'960px': '75vw', '640px': '100vw'}"
                        :style="{width: '70vw'}"
                        v-bind:header="editTemplate.name + ' sablon szerkesztése'" @hide="hideDialog"
                        :modal="true" class="p-fluid">

                    <div class="field mb-4">
                        <label>Elérhető változók</label>
                        <div>
                            <Tag v-for="variable in editTemplate.availableVariables" :key="variable"
                                 :value="'{' + variable + '}'" class="mr-2 mb-1" severity="info" />
                            <small class="block mt-1 text-500">Ezeket a változókat használhatod a sablon szövegében. A rendszer automatikusan behelyettesíti az értéküket.</small>
                        </div>
                    </div>

                    <TabView :style="{minHeight: '500px'}">
                        <TabPanel header="Magyar">
                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="subject">Tárgy</label>
                                    <InputText id="subject" v-model.trim="editTemplate.subject" required="true"
                                               :class="{'p-invalid': submitted && !editTemplate.subject}"/>
                                    <small class="p-invalid" v-if="submitted && !editTemplate.subject">Tárgy megadása kötelező.</small>
                                </div>
                            </div>
                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="bodyHu">Tartalom</label>
                                    <ckeditor :editor="editor" v-model="editTemplate.bodyHu" required="true" :config="editorConfig"></ckeditor>
                                    <small class="p-invalid" v-if="submitted && !editTemplate.bodyHu">Tartalom megadása kötelező.</small>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Angol">
                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="subjectEnglish">Tárgy angolul</label>
                                    <InputText id="subjectEnglish" v-model.trim="editTemplate.subjectEnglish"/>
                                </div>
                            </div>
                            <div class="formgrid grid">
                                <div class="field col">
                                    <label for="bodyEn">Tartalom angolul</label>
                                    <ckeditor :editor="editor" v-model="editTemplate.bodyEn" :config="editorConfig"></ckeditor>
                                </div>
                            </div>
                        </TabPanel>
                    </TabView>
                    <template #footer>
                        <Button label="Mégse" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
                        <Button label="Mentés" icon="pi pi-check" class="p-button-success" @click="save"
                                :loading="saveLoading"/>
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import {FilterMatchMode} from 'primevue/api';
import GlobalEmailTemplateService from "@/service/GlobalEmailTemplateService";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/hu';

export default {
    data() {
        return {
            total: 0,
            templates: null,
            editDialog: false,
            editTemplate: {},
            filters: {},
            submitted: false,
            loading: true,
            saveLoading: false,
            permissionDenied: true,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: [
                        'heading', '|',
                        'bold', 'italic',
                        'link', '|',
                        'outdent', 'indent', '|',
                        'bulletedList', 'numberedList', '|',
                        'undo', 'redo'
                    ],
                    shouldNotGroupWhenFull: true
                }
            },
        }
    },
    globalEmailTemplateService: null,
    created() {
        this.globalEmailTemplateService = new GlobalEmailTemplateService();
        this.initFilters();
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('userData'));

        if (user.role === 1) {
            this.permissionDenied = true;
        } else {
            this.permissionDenied = false;
            this.getAll();
        }
    },
    methods: {
        getAll() {
            this.loading = true;
            this.globalEmailTemplateService.getAll().then(response => {
                this.total = response.data.total;
                this.templates = response.data.data;
                this.loading = false;
            });
        },
        edit(template) {
            this.editTemplate = {...template};
            this.submitted = false;
            this.editDialog = true;
        },
        hideDialog() {
            this.editDialog = false;
            this.submitted = false;
        },
        save() {
            this.submitted = true;

            if (!this.editTemplate.subject || !this.editTemplate.bodyHu) {
                return;
            }

            this.saveLoading = true;

            const data = {
                subject: this.editTemplate.subject,
                subjectEnglish: this.editTemplate.subjectEnglish || '',
                bodyHu: this.editTemplate.bodyHu,
                bodyEn: this.editTemplate.bodyEn || '',
            };

            this.globalEmailTemplateService.update(this.editTemplate.id, data).then(() => {
                this.editDialog = false;
                this.editTemplate = {};
                this.getAll();

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sikeres művelet!',
                    detail: 'Az email sablon mentése sikeres volt.',
                    life: 5000
                });

                this.saveLoading = false;
            }).catch(e => {
                this.$toast.add({
                    severity: "error",
                    summary: "Sikertelen művelet!",
                    detail: e.response?.data?.error || 'Ismeretlen hiba történt.',
                    life: 6000,
                });

                this.saveLoading = false;
            });
        },
        initFilters() {
            this.filters = {
                'global': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'name': {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS
                }
            }
        }
    }
}
</script>

<style>
.ck-balloon-panel {
  z-index: 10000 !important;
}
</style>
<style scoped lang="scss">
@import '../../assets/demo/badges.scss';
</style>

